export enum AuthorizationType {
  PERMANENT,
  TEMPORARY,
}
